export const COLOR_CODES = [
    '#5856D6',
    '#9333EA',
    '#7C3AED',
    '#4F46E5',
    '#2563EB',
    '#C026D3',
    '#E879F9',
    '#C084FC',
    '#A78BFA',
    '#818CF8',
    '#60A5FA',
    '#38BDF8',
    '#0284C7',
    '#0891B2',
    '#0D9488',
    '#22D3EE',
    '#2DD4BF',
]

export const RISK_FACTORS = {
    'Rooted': { label: 'Rooted', value: "Rooted", color: COLOR_CODES[0] },
    'Emulator': { label: 'Emulator', value: "Emulator", color: COLOR_CODES[1] },
    'Geo_Spoofing': { label: 'Geo Spoofing', value: "Geo_Spoofing", color: COLOR_CODES[2] },
    // Dev note : Temporary disable
    'App_Tampering': { label: 'App Tampering', value: "App_Tampering", color: COLOR_CODES[3] },
    'Auto_Clicker': { label: 'Auto Clicker', value: "Auto_Clicker", color: COLOR_CODES[4] },
    'App_Cloned': { label: 'App Cloned', value: "App_Cloned", color: COLOR_CODES[5] },
    'VPN_Enabled': { label: 'VPN Enabled', value: "VPN_Enabled", color: COLOR_CODES[6] },
    'Jail_Broken': { label: 'Jail Broken', value: "Jail_Broken", color: COLOR_CODES[7] },
    'Factory_Reset': { label: 'Factory Reset', value: "Factory_Reset", color: COLOR_CODES[8] },
    'Virtual_OS': { label: 'App Virtualization', value: "Virtual_OS", color: COLOR_CODES[9] },
    'Hooking': { label: 'Hooking', value: "Hooking", color: COLOR_CODES[10] },
    'Device_Mask': { label: 'Device Mask', value: "Device_Mask", color: COLOR_CODES[11] },
    // 'Debugging': { label: 'Debugging', value: "Debugging", color: COLOR_CODES[12] },
    'Screen_Sharing': { label: 'Screen Sharing', value: "Screen_Sharing", color: COLOR_CODES[13] },
    'Custom_ROM': { label: 'Custom ROM', value: "Custom_ROM", color: COLOR_CODES[14] },
    'xHtp': { label: 'Http Proxy', value: "xHtp", color: COLOR_CODES[15] },
    'IncognitoMode': { label: 'Incognito Mode', value: "IncognitoMode", color: COLOR_CODES[0] },
    'Bots': { label: 'Bots', value: "Bots", color: COLOR_CODES[1] },
    'Multi_Account': { label: 'Multi Account', value: "Multi_Account", color: COLOR_CODES[2] },
}

Object.freeze(RISK_FACTORS);

export const DEVICE_ATTRIBUTE = {
    // Device Info
    '_id': '_id',
    'xId': 'xId',
    'platform': 'platform',
    'Device_Brand': 'Device_Brand',
    'Device_Model': 'Device_Model',
    'Device_Name': 'Device_Name',
    'Device_Ram': 'Device_Ram',
    'Battery_Level': 'Battery_Level',
    'Battery_Temp': 'Battery_Temp',
    'Carrier_Name': 'Carrier_Name',
    'Carrier_Country': 'Carrier_Country',
    'Battery_Technology': 'Battery_Technology',
    'Battery_Voltage': 'Battery_Voltage',
    'Battery_Health': 'Battery_Health',
    'Carrier_Country_Code': 'Carrier_Country_Code',
    'Carrier_Network_Code': 'Carrier_Network_Code',
    'GPS_Coordinate': 'GPS_Coordinate',
    'IP_Country': 'IP_Country',
    'Screen_Size': 'Screen_Size',
    'Pixel_Density': 'Pixel_Density',
    'User_Language': 'User_Language',
    'IP_Address': 'IP_Address',
    'Time_Zone': 'Time_Zone',
    'Screen_Height': 'Screen_Height',
    'Screen_Breadth': 'Screen_Breadth',
    'CPU_Architecture': 'CPU_Architecture',
    'OS_Version': 'OS_Version',
    'Merchant_App_Version': 'Merchant_App_Version',
    'IdentX_SDK': 'IdentX_SDK',
    'Session_Id': 'Session_Id',
    'Latitude': 'Latitude',
    'Longitude': 'Longitude',
    'Browser_Name': 'Browser_Name',
    'Device_OS': 'Device_OS',
    // Risk Related
    'Risk_Score': 'Risk_Score',
    ...Object.keys(RISK_FACTORS).reduce((acc, key) => {
        acc[key] = key;
        return acc;
    }
    , {}),
};

Object.freeze(DEVICE_ATTRIBUTE);
